import React, {Fragment, useContext, useState} from 'react';
import {Typography} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ErrorIcon from '@material-ui/icons/Error';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import axios from "axios";
import {useAuth0} from "@auth0/auth0-react";
import {makeStyles} from "@material-ui/core/styles";
import {useHistory} from "react-router-dom";
import AuthContext from "../../../../../context/AuthContext";

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%'
    },
    gridContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: theme.spacing(3)
    },
    centerText: {
        textAlign: 'center'
    },
    buttons: {
        display: 'flex',
        flexDirection:"row",
        justifyContent: 'center'
    },
    buttonContained: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "20px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
}));

function EmisionSuccess(props) {
    const classes = useStyles();
    const history = useHistory();
    const {finalValues, emisionResponse, applyDiscounts, setActiveStep, setEmisionResponse} = props;
    const [selectedDocument, setSelectedDocument] = useState(emisionResponse['status'] === "Pending"
        ? "Certificado de Cobertura" : "Póliza");
    const {getIdTokenClaims} = useAuth0();

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null
    };


    const {authToken} = useContext(AuthContext)
    async function getDocument() {
        // const claims = await getIdTokenClaims();
        // const id_token = claims.__raw;
        let url = process.env.REACT_APP_BACK_SERVER + '/documentacion';

        let body = {
            "origen": "affinity",
            "document": selectedDocument,
            "managementNumber": emisionResponse['managementNumber'],
            "officialNumber": emisionResponse['officialNumber'],
            "referenceNumber": emisionResponse['referenceNumber']
        };
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        };

        axios.post(url, body, {headers: headers}
        ).then(res => {
            //FileDownload(res.data, `${selectedDocument}${emisionResponse['referenceNumber']}.pdf`);
            openInNewTab(res.data)
        }).catch(err => {
            console.log(err);
        });
    }

    return (
        <Fragment>
            {emisionResponse['status'] !== "Failed"
                ? (
                    <Fragment>
                        {/*<Typography variant="h5" gutterBottom>*/}
                        {/*    Número de Referencia: {emisionResponse['referenceNumber']}*/}
                        {/*</Typography>*/}
                        <Typography variant="subtitle1" gutterBottom>
                            Número Oficial de Póliza: {emisionResponse['status'] === "Pending"
                            ? "Pendiente"
                            : emisionResponse['officialNumber']}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            Número de Trámite: {emisionResponse['managementNumber']}
                        </Typography>
                        <Divider/>
                        <Grid container spacing={3} className={classes.gridContainer}>
                            <Grid item xs={12} sm={4} className={classes.centerText}>
                                <Typography variant="h6">
                                    Documentación
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel htmlFor="documentSelect">Documento</InputLabel>
                                    {emisionResponse['status'] === "Success"
                                        ? (
                                            <Select
                                                value={selectedDocument}
                                                onChange={(e) => setSelectedDocument(e.target.value)}
                                                name='documentSelect'
                                            >
                                                <MenuItem key={0} value={"Póliza"}>Póliza</MenuItem>
                                                {emisionResponse["DebitType"] === '0'   // Efectivo
                                                    ? <MenuItem key={1} value={"Cupón de Pago"}>Cupón de
                                                        Pago</MenuItem>
                                                    : <MenuItem key={1} value={"Factura"}>Factura</MenuItem>
                                                }
                                                <MenuItem key={2} value={"Certificado de Cobertura"}>
                                                    Certificado de Cobertura
                                                </MenuItem>
                                            </Select>
                                        )
                                        : (
                                            <Select
                                                value={selectedDocument}
                                                onChange={(e) => setSelectedDocument(e.target.value)}
                                                name='documentSelect'
                                            >
                                                <MenuItem key={0} value={"Certificado de Cobertura Provisoria"}>
                                                    Certificado de Cobertura Provisoria
                                                </MenuItem>
                                            </Select>
                                        )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} className={classes.centerText}>
                                <Button
                                    onClick={() => {
                                        getDocument()
                                    }}
                                    variant='contained'
                                    color="primary"
                                    className={classes.buttonContained}
                                >
                                    Obtener
                                </Button>
                            </Grid>
                            {emisionResponse['status'] === "Pending" && (
                                <Fragment>
                                    <Divider/>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            El certificado de cobertura provisoria es un documento válido para la
                                            circulación y cobertura del vehículo.
                                            En el transcurso de 5 días hábiles estará disponible el resto de la
                                            documentación.
                                        </Typography>
                                    </Grid>
                                </Fragment>
                            )}
                        </Grid>
                    </Fragment>
                )
                : (
                    <Fragment>
                        <Typography variant="h5" gutterBottom>
                            Ocurrió un error al procesar el pedido.
                        </Typography>
                        <List>
                            {emisionResponse?.errors.map((row) => (
                                <ListItem>
                                    <ListItemIcon>
                                        <ErrorIcon/>
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={row['detail'] === 'Internal Error' ? 'Hay un problema con el servicio, vuelva a intentarlo más tarde.' : row['detail']}
                                    />
                                </ListItem>
                            ))}
                        </List>
                        <div className={classes.centerText}>
                            <Button
                                variant='contained'
                                color="primary"
                                className={classes.buttonContained}
                                onClick={() => {
                                    finalValues.bienesAsegurados.map((bien, index) => {
                                        if (bien.id === "1")
                                            finalValues.bienesAsegurados.splice(index, 1)
                                    })

                                    history.push({
                                        pathname: "/u/emitir/vehiculo",
                                        state: {
                                            emisionValues: finalValues,
                                            recotizar: !applyDiscounts
                                        }
                                    })
                                    setEmisionResponse(null)
                                    setActiveStep(0)
                                }}
                            >
                                Volver al Formulario
                            </Button>
                        </div>
                    </Fragment>
                )}
        </Fragment>
    );
}

export default EmisionSuccess;
